"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _proptypes = require("../utils/proptypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Item =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Item, _React$PureComponent);

  function Item(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Item.prototype;

  _proto.handleClick = function handleClick() {
    if (!this.props.onClick) return;
    this.props.onClick(this.props.data);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        itemClassName = _this$props.itemClassName,
        renderItem = _this$props.renderItem,
        width = _this$props.width,
        columns = _this$props.columns;
    var aWidth = width && columns ? (width - 2) / columns : undefined;
    var props = {
      disabled: data.disabled,
      onClick: this.handleClick,
      className: itemClassName,
      href: data.url ? data.url : 'javascript:;',
      target: data.target,
      style: aWidth ? {
        display: 'inline-block',
        width: aWidth
      } : null
    };
    var content;

    if ((0, _react.isValidElement)(data)) {
      content = data;
    } else {
      content = typeof renderItem === 'string' ? data[renderItem] : renderItem(data);
    }

    if ((0, _react.isValidElement)(content)) {
      return (0, _react.cloneElement)(content, Object.assign(props, content.props));
    }

    return _react.default.createElement("a", props, content);
  };

  return Item;
}(_react.default.PureComponent);

Item.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default), {
  data: _propTypes.default.object,
  onClick: _propTypes.default.func,
  renderItem: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  columns: _propTypes.default.number
});
Item.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  data: {},
  renderItem: 'content'
});
var _default = Item;
exports.default = _default;